import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['before', 'beforeInner', 'after', 'bar', 'autoMovePointer']
  static values = { position: { type: Number, default: 0.8 }, autoMove: { type: Boolean, default: false } }

  connect() {
    if (this.autoMoveValue) {
      this.intervalId = window.setInterval(this.autoMove.bind(this), 10)
    } else {
      this.pointerMoveEventListener = this.move.bind(this)
      this.pointerUpEventListener = this.end.bind(this)
    }
    this.resizeEventListener = this.syncWidth.bind(this)
    window.addEventListener('resize', this.resizeEventListener)
    this.syncWidth()
  }

  disconnect() {
    if (this.autoMoveValue) {
      window.clearInterval(this.intervalId)
      this.intervalId = null
    } else {
      this.end()
    }
    window.removeEventListener('resize', this.resizeEventListener)
    this.pointerMoveEventListener = null
    this.pointerUpEventListener = null
    this.resizeEventListener = null
  }

  start(e) {
    this.startX = e.clientX
    this.startPosition = this.positionValue
    document.addEventListener('pointermove', this.pointerMoveEventListener)
    document.addEventListener('pointerup', this.pointerUpEventListener)
  }

  move(e) {
    const relativePosition = (e.clientX - this.startX) / this.element.getBoundingClientRect().width
    this.positionValue = Math.max(0, Math.min(1, this.startPosition + relativePosition))
  }

  end() {
    document.removeEventListener('pointermove', this.pointerMoveEventListener)
    document.removeEventListener('pointerup', this.pointerUpEventListener)
    this.startX = null
    this.startPosition = null
  }

  autoMove() {
    const elementRect = this.element.getBoundingClientRect()
    const pointerRect = this.autoMovePointerTarget.getBoundingClientRect()
    this.positionValue = (pointerRect.x - elementRect.x) / elementRect.width
  }

  syncWidth() {
    this.beforeInnerTarget.style.width = `${this.afterTarget.getBoundingClientRect().width}px`
  }

  preventSwipeNavigation(e) {
    const x = e.targetTouches[0].pageX
    if (x <= 30 || x >= window.innerWidth - 30) {
      e.preventDefault()
    }
  }

  positionValueChanged(value) {
    this.beforeTarget.style.width = `${value * 100}%`
    this.barTarget.style.left = `${value * 100}%`
  }
}
